import 'swiper/css';
import 'swiper/css/pagination';
import './styles/SwiperCustomPagination.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

export function ProfilePhotos({ children, photos, heightClassName }) {
  return (
    <div className="relative w-full rounded-[16px]">
      <div className="w-full relative">
        <div
          className="custom-pagination"
          style={{
            position: 'absolute',
            top: 0,
            zIndex: 10,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        ></div>
      </div>
      <div className="relative">
        <Swiper
          modules={[Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          className={`w-full ${heightClassName || 'h-[560px]'} rounded-tl-[16px] rounded-tr-[16px]`}
          pagination={{
            el: '.custom-pagination',
          }}
        >
          {photos && photos.length > 0 ? (
            photos.map((photo, index) => (
              <SwiperSlide key={index}>
                <img src={photo} alt={`Фото ${index + 1}`} className={`z-[1] w-full ${heightClassName || 'h-[544px]'} object-cover`} />
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide>
              <div className={`z-[1] w-full ${heightClassName || 'h-[544px]'} bg-[#FFFFFF1A] flex items-center justify-center text-white`}>
                Фото не загружены
              </div>
            </SwiperSlide>
          )}
        </Swiper>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-4 z-10">{children}</div>
        <div
          className="absolute left-0 right-0 bottom-0 w-full h-[150px] z-[5] pointer-events-none"
          style={{
            background: 'linear-gradient(to top, black 30%, transparent 100%)',
          }}
        />
      </div>
    </div>
  );
}
